
const config = {
  apiPath: process.env.REACT_APP_API_PATH,
}
export default config
